import { reduxKey } from './constants';
export function getSiteHeaderState(state) {
    return (state[reduxKey] || {
        isSearchPopupShown: false,
        isNotificationsDropdownOpen: false,
        isSubmitMenuOpen: false,
        isUserDropdownOpen: false,
    });
}
//# sourceMappingURL=selectors.js.map